import * as React from 'react';

type Props = {
  // Original propType: object
  style?: $TSFixMe;
  // Original propType: object
  htmlAttributes?: $TSFixMe;
  children?: React.ReactNode;
  color?: string;
  isThemeDark?: boolean;
  size?: number;
  hoverColor?: string;
  onMouseEnter?: (e: $TSFixMe) => void;
  onMouseLeave?: (e: $TSFixMe) => void;
  viewBox?: string;
  hovered?: boolean;
  disableMouseEvent?: boolean;
};

type State = {
  hovered: boolean;
};

const defaultSvgIcon = {
  display: 'inline-block',
  color: 'var(--cds-color-neutral-primary)',
  transition: 'cubic-bezier(0.0, 0, 0.2, 1)',
  userSelect: 'none',
};
// Dynamic styles
function getStyles({ propColor, hoverColor, size, hovered }: $TSFixMe) {
  return {
    SvgIcon: {
      fill: hovered && hoverColor ? hoverColor : propColor,
      height: size,
      width: size,
    },
  };
}

class SvgIcon extends React.Component<Props, State> {
  static defaultProps = {
    onMouseEnter: () => {},
    onMouseLeave: () => {},
    viewBox: '0 0 24 24',
    size: 24,
    style: {},
    htmlAttributes: {},
  };

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);
    const { color: colorAlt, hoverColor, isThemeDark, hovered } = props;
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_color' does not exist on type 'SvgIcon'... Remove this comment to see the full error message
    this._color = colorAlt || (isThemeDark ? 'var(--cds-color-grey-25)' : 'var(--cds-color-neutral-primary)');
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_hoverColor' does not exist on type 'Svg... Remove this comment to see the full error message
    this._hoverColor = hoverColor || this._color;
    this.state = {
      hovered: !!hovered,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: $TSFixMe) {
    const { hovered } = this.state;
    if ('hovered' in nextProps && nextProps.hovered !== hovered) {
      this.setState({ hovered: nextProps.hovered });
    }
  }

  handleMouseLeave = (e: $TSFixMe) => {
    const { disableMouseEvent, onMouseLeave } = this.props;
    if (!disableMouseEvent) {
      this.setState({ hovered: false });
      if (onMouseLeave) {
        onMouseLeave(e);
      }
    }
  };

  handleMouseEnter = (e: $TSFixMe) => {
    const { disableMouseEvent, onMouseEnter } = this.props;
    if (!disableMouseEvent) {
      this.setState({ hovered: true });
      if (onMouseEnter) {
        onMouseEnter(e);
      }
    }
  };

  render() {
    const { style, children, size, viewBox, htmlAttributes } = this.props;
    const { hovered } = this.state;

    const dynamicStyles = getStyles({
      // @ts-expect-error ts-migrate(2339) FIXME: Property '_color' does not exist on type 'SvgIcon'... Remove this comment to see the full error message
      propColor: this._color,
      // @ts-expect-error ts-migrate(2339) FIXME: Property '_hoverColor' does not exist on type 'Svg... Remove this comment to see the full error message
      hoverColor: this._hoverColor,
      size,
      hovered,
    });
    const mergedStyles = { ...defaultSvgIcon, ...dynamicStyles.SvgIcon, ...style };

    return (
      <svg
        {...htmlAttributes}
        style={mergedStyles}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
      >
        {children}
      </svg>
    );
  }
}

export default SvgIcon;
